/**
 *
 * @param {Number} order
 * @param {Array<String>} ordered
 * @param {Array<String>} unordered
 * @param {String} current
 */
const fillOrderArray = (order, ordered, unordered, current) => {
  if (order) {
    ordered[order] = current;
  } else {
    unordered.push(current);
  }
};

export default fillOrderArray;
